import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export type IObjTypeCellProps = {
  value: number;
};

export const ObjTypeCell = (props: IObjTypeCellProps) => {
  const { value } = props;
  const { t } = useTranslation();

  if (value == null) {
    return null;
  }

  return <Typography>{t(`NUMBERINGLOGIC.${value}`)}</Typography>;
};
